import { Col, Row, Table } from "react-bootstrap";
import styled from "styled-components";

import { InquirySummary } from "../types/InquiryInfo";

type Props = {
  Summaries: InquirySummary[] | null;
};

export const InquirySummaryTable = ({ Summaries }: Props) => {
  return (
    <>
      <h4>合計件数</h4>
      <Row>
        <Col xs={12} md={7}>
          <Table bordered hover responsive className="summary-table">
            <thead>
              <tr className="text-center">
                <Sth2 className="col-md-2">要求種別</Sth2>
                <Sth1 className="col-md-1">来園</Sth1>
                <Sth1 className="col-md-1">電話</Sth1>
                <Sth1 className="col-md-1">Eメール</Sth1>
                <Sth1 className="col-md-1">その他</Sth1>
                <Sth1 className="col-md-1">合計</Sth1>
              </tr>
            </thead>
            <tbody>
              {Summaries &&
                Summaries.map((x) => {
                  return (
                    <tr
                      key={`sum_${x.typeID}`}
                      className={`text-end ${x.typeID === -1 && "row-total"}`}
                    >
                      <td className="text-start">{x.typeName}</td>
                      <td>{x.visit}</td>
                      <td>{x.phone}</td>
                      <td>{x.email}</td>
                      <td>{x.others}</td>
                      <td>{x.total}</td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
};

const Sth1 = styled.th`
  min-width: 60px;
`;

const Sth2 = styled.th`
  min-width: 100px;
`;
